import React, { Component } from 'react';
import axios from '../../utils/request';
import { Spinner } from 'reactstrap';
import { Result } from 'antd';

export class OperationSuccess extends Component {
    constructor(props) {
        super(props);
        this.state = {
            message: "",
            isReady: false,
            sendStatus: false,
        };
    };

    componentDidMount() {
        const urlParams = new URLSearchParams(window.location.search);
        const content = urlParams.get("content");
        const type = urlParams.get("type");
        const commonParamater = urlParams.get("commonParamater");
        const tenantId = urlParams.get("tenantId");
        const params = {
            content,
            type,
            tenantId,
            commonParamater
        }
        axios.get("/api/MaiRui/Entry", { params: params })
            .then(res => {
                const data = res.data.data;
                if (data == "") {
                    this.setState({ sendStatus: true, isReady: true, message: "录入成功，点击右上角关闭" });
                } else {
                    this.setState({ sendStatus: false, isReady: true, message: data });
                }
            })
    };

    render() {
        if (this.state.isReady) {
            if (this.state.sendStatus) {
                return (
                    <Result
                        status="success"
                        title="录入成功"
                        subTitle="录入成功，录入信息可在应聘者信息中查看，点击右上角关闭此页面."
                    />
                )
            } else {
                return (
                    <Result
                        status="warning"
                        title="录入Offer批次失败，请联系管理员"
                        subTitle={this.state.message}
                    />)
            }
        } else {
            return (
                <div style={{ textAlign: "center", lineHeight: "100vh" }}>
                    <Spinner type="grow" color="primary" />
                    <Spinner type="grow" color="secondary" />
                    <Spinner type="grow" color="success" />
                    <Spinner type="grow" color="danger" />
                    <Spinner type="grow" color="warning" />
                    <Spinner type="grow" color="info" />
                    <Spinner type="grow" color="dark" />
                </div>
            );
        }
    }
}
